import React, { Component } from 'react';
import { func } from 'prop-types';
import Button from 'ps-components/Button/Button';
import './SalaryRangeFooter.scss';

class SalaryRangeFooter extends Component {
  static propTypes = {
    closeSlideout: func,
    updateRange: func
  };

  render() {
    const { closeSlideout, updateRange } = this.props;

    return (
      <div className="salary__range-actions">
        <a onClick={closeSlideout}>Cancel</a>
        <Button className="pxl-btn pxl-btn-primary pxl-margin-small" onClick={updateRange}>
          Save changes
        </Button>
      </div>
    );
  }
}

export default SalaryRangeFooter;
